'use client';

import { Button, Icons, Label, Switch } from '@commenda/kakashi';
import { useFormEditor } from '../hooks/useFormEditor';

interface TemplatesHeaderProps {
  // Key management is an admin concern; a host that omits it gets no Create Key button.
  onCreateKey?: () => void;
  onCreateTemplate: () => void;
  showDevModeToggle?: boolean;
  /** Console pages title their header; admin leaves it off and keeps the dev-mode toggle there. */
  title?: string;
}

export function TemplatesHeader({
  onCreateKey,
  onCreateTemplate,
  showDevModeToggle = true,
  title,
}: TemplatesHeaderProps) {
  const { devMode, setDevMode } = useFormEditor();

  return (
    <div className="flex items-center justify-between px-6 py-4 bg-bg-primary border-b border-border-secondary">
      <div className="flex items-center gap-2">
        {title && (
          <h1 className="display-xs-bold text-text-primary">{title}</h1>
        )}
        {showDevModeToggle && (
          <>
            <Label
              htmlFor="devModeToggle"
              className="txt-xs-regular text-text-tertiary"
            >
              Dev Mode
            </Label>
            <Switch
              id="devModeToggle"
              checked={devMode}
              onCheckedChange={setDevMode}
              size="sm"
            />
          </>
        )}
      </div>
      <div className="flex items-center gap-3">
        {onCreateKey && (
          <Button variant="primary" size="sm" onClick={onCreateKey}>
            <Icons.Plus className="w-4 h-4" />
            Create Key
          </Button>
        )}
        <Button variant="primary" size="sm" onClick={onCreateTemplate}>
          <Icons.Plus className="w-4 h-4" />
          Create Template
        </Button>
      </div>
    </div>
  );
}
